import { Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-complete-info-modal',
  templateUrl: './complete-info-modal.component.html',
  styleUrls: ['./complete-info-modal.component.scss']
})
export class CompleteInfoModalComponent {
  @ViewChild('completeInfoModal') completeInfoTemplate!: TemplateRef<CompleteInfoModalComponent>;
}
